<template>
    <div>
        <!-- Success alert -->
        <div v-if="success" class="alert alert-success">
            {{success}}
        </div>
        <!-- Address Details -->
        <h4 v-html="$t('intern_inserieren.title_billing_address')"></h4>
        <div v-if="address && postcode && city">
            <p>
                {{company}} <br>
                {{title}} {{title_ext}} {{forename}} {{surname}} <br>
                {{address}} {{address_ext}} <br>
                {{postcode}} {{city}} {{country}}<br>
                {{phone}}
            </p>
            <a class="font-weight-bold pointer text-danger mb-2" @click.prevent="removeAddress">Rechnungsadresse löschen</a> <br>
            <a class="mm-link" @click="toggleAddress">{{$t('intern_inserieren.felder_unternehmen_aendern')}}</a>
        </div>
        <div v-else>
            <p>{{$t('intern_inserieren.felder_unternehmen_leer')}}</p>
            <a class="mm-link" @click="toggleAddress">{{$t('intern_inserieren.felder_unternehmen')}}</a>
        </div>

        <!-- Display errors -->
        <div class="alert alert-danger mt-3" style="overflow: auto" v-if="error.length > 0">
            <template v-for="err in error">
                {{err}}<br/>
            </template>
            <button type="button" class="close" @click="error = []" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div v-if="toggle">
            <div class="row mt-3">
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="title">Anrede</label>
                        <select v-model="title" id="title" class="form-control">
                            <option value=""></option>
                            <option value="Herr">Herr</option>
                            <option value="Frau">Frau</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="title_extra">Anredezusatz</label>
                        <input type="text" id="title_extra" v-model.trim="title_ext" class="form-control">
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="company">Firma</label>
                        <input type="text" id="company" v-model.trim="company" class="form-control">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="forename">Vorname*</label>
                        <input type="text" id="forename" @blur="$v.forename.$touch()" v-model.trim="forename" :class="{ 'is-invalid': $v.forename.$error }" class="form-control">
                        <div class="invalid-feedback" v-if="!$v.forename.required">Bitte Vorname eingeben</div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="surname">Nachname*</label>
                        <input type="text" id="surname" @blur="$v.surname.$touch()" v-model.trim="surname" :class="{ 'is-invalid': $v.surname.$error }" class="form-control">
                        <div class="invalid-feedback" v-if="!$v.surname.required">Bitte Nachname eingeben</div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="address">Straße / Hausnummer*</label>
                        <input type="text" id="address" @blur="$v.address.$touch()" v-model.trim="address" :class="{ 'is-invalid': $v.address.$error }" class="form-control">
                        <div class="invalid-feedback" v-if="!$v.address.required">Bitte Straße / Hausnummer eingeben</div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="address_extra">Adresszusatz</label>
                        <input type="text" id="address_extra" v-model.trim="address_ext" class="form-control">
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="postcode">PLZ*</label>
                        <input type="text" id="postcode" @blur="$v.postcode.$touch()" v-model.trim="postcode" :class="{ 'is-invalid': $v.postcode.$error }" class="form-control">
                        <div class="invalid-feedback" v-if="!$v.postcode.required">Bitte PLZ eingeben</div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="city">Ort*</label>
                        <input type="text" id="city" @blur="$v.city.$touch()" v-model.trim="city" :class="{ 'is-invalid': $v.city.$error }" class="form-control">
                        <div class="invalid-feedback" v-if="!$v.city.required">Bitte Ort eingeben</div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="country">Land</label>
                        <input type="text" id="country" v-model.trim="country" class="form-control">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="phone">Telefon-Nummer</label>
                        <input type="text" id="phone" v-model.trim="phone" class="form-control">
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="mobile">Mobil-Nummer</label>
                        <input type="text" id="mobile" v-model.trim="mobile" class="form-control">
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="homepage">Homepage</label>
                        <input type="text" id="homepage" v-model.trim="homepage" class="form-control">
                    </div>
                </div>
            </div>
            <div class="mt-3">
                <button class="btn btn-success" @click="submit">Speichern</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { required } from 'vuelidate/lib/validators';

    export default {
        data() {
            return {
                title: '',
                title_ext: '',
                company: '',
                forename: '',
                surname: '',
                address: '',
                address_ext: '',
                postcode: '',
                city: '',
                country: '',
                phone: '',
                mobile: '',
                homepage: '',
                error: [],
                success: '',
                toggle: false
            }
        },
        methods: {
            submit() {
                this.$v.$touch();
                if(!this.$v.$invalid){
                    this.$store.state.loading = true;
                    const data = {
                        title:       this.title,
                        title_ext:   this.title_ext,
                        company:     this.company,
                        forename:    this.forename,
                        surname:     this.surname,
                        address:     this.address,
                        address_ext: this.address_ext,
                        postcode:    this.postcode,
                        city:        this.city,
                        country:     this.country,
                        phone:       this.phone,
                        mobile:      this.mobile,
                        homepage:    this.homepage
                    };
                    this.$http.post('/userApi/editInvoiceAddress', data).then((response) => {
                        this.$store.state.loading = false;
                        this.returnIfAddressExists();
                        this.$emit('ADDRESS_STORED');
                    }).catch(error => {
                        let data     = JSON.parse(error.response.data.data);
                        this.error   = data;
                        this.$store.state.loading = false;
                    });
                }
            },
            toggleAddress() {
                this.toggle = !this.toggle;
            },
            removeAddress() {
                this.$bvModal.msgBoxConfirm('Bitte bestätigen Sie, dass Sie die Adresse löschen möchten', {
                    title: 'Bestätigung',
                    okVariant: 'danger',
                    okTitle: 'Löschen',
                    cancelTitle: 'Nein'
                }).then( value => {
                    if(value) {
                        this.$store.state.loading = true;

                        this.$http.delete('/userApi/removeInvoiceAddress').then( response => {
                            this.success = 'Die abweichende Rechnungsadresse ist erfolgreich gelöscht';
                            this.$store.state.loading = false;
                            this.getInvoiceAddress();

                            setTimeout(() => {
                                this.success = '';
                            }, 3000);
                        }).catch(error => {
                            console.log(error);
                            this.$store.state.loading = false;
                        });
                    }
                }).catch( error => {console.log(error);});
            },
            getInvoiceAddress() {
                this.$http.get('/userApi/getInvoiceAddress').then( response => {
                    let data         = JSON.parse(response.data);
                    if(data.exists){
                        let address      = data.address;
                        this.title       = address.title;
                        this.title_ext   = address.title_ext;
                        this.company     = address.company;
                        this.forename    = address.firstname;
                        this.surname     = address.lastname;
                        this.address     = address.street;
                        this.city        = address.city;
                        this.postcode    = address.plz;
                        this.address_ext = address.address_ext;
                        this.country     = address.country;
                        this.phone       = address.phone;
                        this.mobile      = address.mobile;
                        this.homepage    = address.homepage;

                        this.returnIfAddressExists();
                    }else {
                        this.title       = '';
                        this.title_ext   = '';
                        this.company     = '';
                        this.forename    = '';
                        this.surname     = '';
                        this.address     = '';
                        this.city        = '';
                        this.postcode    = '';
                        this.address_ext = '';
                        this.country     = '';
                        this.phone       = '';
                        this.mobile      = '';
                        this.homepage    = '';

                    }
                }).catch( error => {
                    console.log(error);
                });
            },
            returnIfAddressExists() {
                if(this.forename && this.surname && this.address && this.postcode && this.city){
                    this.$emit('initial', true);
                }
            }
        },
        mounted() {
            this.getInvoiceAddress();
        },
        validations: {
            forename: {required},
            surname: {required},
            address: {required},
            city: {required},
            postcode: {required},
        }
    }
</script>

<style scoped>

</style>
